<div class="horizontal-banner" *ngIf="selectedBannerList.length > 0">
        <div *ngFor="let banner of selectedBannerList;let i = index">
                <div style="height: 80px;position: relative;"  *ngIf="displayDirectUrl(banner); else directLinkUrl">
                <!-- <iframe appIframeTracker *ngIf="displayDirectUrl(banner); else directLinkUrl" class="iframeHorizontalBanner" (iframeClick)="onBannerClicked(banner.id)"
                                [src]="banner?.cloudFileName | sanitizeUrl" >
                        </iframe> -->
                          <iframe   class="iframeHorizontalBanner" 
                                [src]="banner.cloudFileName | sanitizeUrl" >
                        </iframe>
                <div style="position: absolute;top:0;left:0;width:100%;height:70px; background:transparent ;" class="bar" (click)="onBannerClicked(banner)"></div>
                </div> 
                <!-- <div [innerHTML]="banner?.html5text | sanitizeHtml" *ngIf="displayDirectUrl(banner); else directLinkUrl" > </div> -->
               
                       
                
                <ng-template #directLinkUrl>
                <div  (click)="onBannerClicked(banner)">
                        <!-- <img src="./api/services/DownloadCloudResource/{{banner?.cloudFileName}}" /> -->
                        <img src="https://marketingdd.blob.core.windows.net/marketing/{{banner?.cloudFileName}}" />
                </div>
        </ng-template>
        </div>
</div>

<!-- <div class="horizontal-banner">
        <ngb-carousel *ngIf="selectedBannerList?.length > 0" wrap="true">
                <ng-template ngbSlide *ngFor="let banner of selectedBannerList;let i = index">
                        <a href="{{banner?.promotionLink}}" target="_blank">

                                <iframe style="position: absolute;" appIframeTracker *ngIf="displayDirectUrl(banner); else directLinkUrl"
                                        class="iframeHorizontalBanner" [src]="banner?.cloudFileName | sanitizeUrl"
                                        (iframeClick)="onBannerClicked(banner.id)" >
                                </iframe>
                                <div style="position: absolute;width: 720px;height:90px;"></div>
                                <ng-template #directLinkUrl>
                                        <img (click)="onBannerClicked(banner.id)"
                                                src="./api/services/DownloadCloudResource/{{banner?.cloudFileName}}" />

                                </ng-template>
                        </a>
                </ng-template>
        </ngb-carousel>
</div> -->